import { render, staticRenderFns } from "./ComponentIndexMovie.vue?vue&type=template&id=01e4d93f"
import script from "./ComponentIndexMovie.vue?vue&type=script&lang=js"
export * from "./ComponentIndexMovie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports